import { ENDPOINTS } from "../endpoints";
import axios from "axios";

export const getNewsLetterById = async (id) => {
  try {
    const response = await axios.get(`${ENDPOINTS.NEWS_LETTER.GET}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export const getNewsLetters = async (session_id, page) => {
  try {
    const response = await axios.get(ENDPOINTS.NEWS_LETTER.GET, {
      params: {
        session_id: session_id,
        page: page
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export const createNewsLetter = async (data) => {
  try {
    const response = await axios.post(ENDPOINTS.NEWS_LETTER.CREATE, data,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export const updateNewsLetter = async (id, data) => {
  try {
    const response = await axios.post(`${ENDPOINTS.NEWS_LETTER.UPDATE}/${id}`, data,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export const deleteNewsLetter = async (id) => {
  try {
    const response = await axios.delete(`${ENDPOINTS.NEWS_LETTER.DELETE}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}
